import { clsx, ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number | string): string {
  const n = typeof amount === "string" ? parseFloat(amount) : amount;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(n);
}

/**
 * Calendar-only fields (start/end dates, due dates, effective dates) are entered with a
 * date picker and stored as midnight UTC. Rendering them in Puerto Rico time would show
 * the previous evening, so they are formatted from their UTC calendar parts, no time.
 */
export function formatDateOnly(date: string | Date | null | undefined, lang = "es"): string {
  if (!date) return "—";
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(lang === "es" ? "es-PR" : "en-US", { dateStyle: "medium", timeZone: "UTC" }).format(d);
}

/** Time only, same locale/timezone as formatDate — for showing "10:00 a. m. – 11:30 a. m." ranges. */
export function formatTimeOnly(date: string | Date, lang = "es"): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat(lang === "es" ? "es-PR" : "en-US", {
    timeStyle: "short",
    timeZone: "America/Puerto_Rico",
  }).format(d);
}

export function formatDate(date: string | Date, lang = "es"): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat(lang === "es" ? "es-PR" : "en-US", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "America/Puerto_Rico",
  }).format(d);
}
